import React from 'react';
import { WhiteLoader } from '@/components/loaders/WhiteLoader';

interface SilaButtonProps {
  onClick?: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  variant?: 'primary' | 'danger' | 'success' | 'neutral';
}

export const SilaButton: React.FC<SilaButtonProps> = ({
  onClick,
  isLoading = false,
  disabled = false,
  children,
  className = '',
  type = 'button',
  variant = 'primary',
}) => {
  const variantClasses = {
    primary: 'bg-orange-500 text-white hover:bg-orange-600 shadow-orange-200',
    danger: 'bg-red-500 text-white hover:bg-red-600 shadow-red-200',
    success: 'bg-green-500 text-white hover:bg-green-600 shadow-green-200',
    neutral: 'bg-gray-200 text-gray-700 hover:bg-gray-300 shadow-none',
  };

  const defaultClasses =
    'p-3 font-bold rounded-lg transition duration-200 shadow-md flex items-center justify-center gap-2';
  const stateClasses =
    disabled || isLoading
      ? 'opacity-50 cursor-not-allowed shadow-none'
      : 'active:transform active:scale-[0.98]';

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || isLoading}
      className={`${defaultClasses} ${variantClasses[variant]} ${stateClasses} ${className}`}
    >
      {isLoading ? <WhiteLoader /> : children}
    </button>
  );
};
